import { useQuery } from '@tanstack/react-query';

import { API } from 'src/reactQuery/Api';
import { getRequest } from 'src/utils/request';
import { QUERY_KEYS } from 'src/reactQuery/QueryKeys';

import type { RequestDataArray } from 'src/types/requestData';

const mapCancellationReasonOptions = (
  attributes: UCM.CancellationReasonOptionRawType,
  id: string,
): UCM.CancellationReasonOptionType => ({
  value: id,
  code: attributes.code,
  label: attributes.title,
  reasonFor: attributes.reason_for,
  explanationNeeded: attributes.explanation_needed,
  actionable: attributes.actionable,
});

const getCancellationReasonOptions = async () => {
  const { data } = await getRequest<
    RequestDataArray<UCM.CancellationReasonOptionRawType>
  >(API.GET.cancellationReasonOptions);
  return data.data.map(({ attributes, id }) =>
    mapCancellationReasonOptions(attributes, id),
  );
};

export const useGetCancellationReasonOptions = (
  config: { enabled?: boolean } = { enabled: true },
) => {
  return useQuery({
    queryKey: [QUERY_KEYS.CANCELLATION_REASON_OPTIONS],
    queryFn: getCancellationReasonOptions,
    ...config,
  });
};
